// eslint-disable-next-line import/prefer-default-export
export const getProducts = (state) => state.products.productsList;
export const getViewedProduct = (state) => state.products.viewedProduct;
